<template>
  <PieChart v-bind:title="title" v-bind:data="data" v-bind:labels="labels" />
</template>

<script>
import PieChart from "@/components/management/statistics/common/PieChart";
import { getAccessByRegionChartData } from "@/api/statisticsV2";

export default {
  components: {
    PieChart,
  },
  data() {
    return {
      title: "Access by Region",
      data: [],
      labels: [],
    };
  },
  // created() {
  //   this.getData();
  // },
  methods: {
    async getData(startDate, endDate) {
      let loader = this.$loading.show({});
      try {
        let response = await getAccessByRegionChartData(startDate, endDate);
        this.labels = response.data.name;
        this.data = response.data.count;
      } finally {
        loader.hide();
      }
    },
    // async getData(year) {
    //   let loader = this.$loading.show({});
    //   let response = await getAccessByRegionChartData(year);
    //   this.labels = response.data.name;
    //   this.data = response.data.count;
    //   loader.hide();
    // },
  },
};
</script>

<style></style>
